import http from './http';

/// MusteriKontrol

export function getMusteriKontrol() {
    return http.get(`/musterikontrol`);
}

export function getMusteriKontrolDetail(id) {
    return http.get(`/musterikontrol/detail/${id}`);
}

export function getMusteriKontrolleri(id) {
    return http.get(`/musterikontrol/musteriKontrolleri/${id}`);
}

export function getMusteriKontrolGenelGorunum() {
    return http.get(`/musterikontrol/gorunum`);
}

export function getMusteriKontrolGun(dateStr) {
    return http.get(`/Musterikontrol/gun/${dateStr}`);
}

export function getKontrolAylikSayi({ year, month }) {
    return http.get(`/musterikontrol/monthlyCount/${year}/${month}`);
}

export function getKontrolAylikTamamlananSayi({ year, month }) {
    return http.get(`/musterikontrol/monthlyDoneCount/${year}/${month}`);
}

export function getKontrolGunluk({ year, month, day }) {
    return http.get(`/musterikontrol/daily/${year}/${month}/${day}`);
}

export function getMusteriKontrolDays(days) {
    if (!days) {
        console.debug('days missing:', days)
    }
    return http.post(`/musterikontrol/range`, { days });
}

export function createMusteriKontrol(data) {
    return http.post(`/musterikontrol/create`, data);
}

export function updateMusteriKontrol(id, data) {
    return http.put(`/musterikontrol/update/${id}`, data);
}

export function deleteMusteriKontrol(id) {
    return http.delete(`/musterikontrol/delete/${id}`);
}
